import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch, } from 'vue';
import { useI18n } from 'vue-i18n';
const JSONLD_ID = 'faq-jsonld';
const setJsonLd = (items) => {
    if (typeof document === 'undefined')
        return;
    const data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map((it) => ({
            '@type': 'Question',
            name: it.q,
            acceptedAnswer: { '@type': 'Answer', text: it.a },
        })),
    };
    let node = document.getElementById(JSONLD_ID);
    if (!node) {
        node = document.createElement('script');
        node.id = JSONLD_ID;
        node.type = 'application/ld+json';
        document.head.appendChild(node);
    }
    node.textContent = JSON.stringify(data);
};
const removeJsonLd = () => {
    if (typeof document === 'undefined')
        return;
    document.getElementById(JSONLD_ID)?.remove();
};
export default defineComponent({
    name: 'FAQ',
    setup() {
        const { tm, t } = useI18n();
        const items = computed(() => tm('faq.items'));
        const open = ref(null);
        const toggle = (idx) => {
            open.value = open.value === idx ? null : idx;
        };
        onMounted(() => setJsonLd(items.value));
        watch(items, (next) => setJsonLd(next));
        onBeforeUnmount(removeJsonLd);
        return { items, open, toggle, t };
    },
});
